<template>
  <div id="app" v-bind:class="{ 'included-in-package fill-bill': step != -1 }">
    <div class="offer-title"  data-swiftype-index="false" v-if="step === -1">
      <h1 v-html="translations.orangeTitle"></h1>
    </div>
    <SelectAmount :translations="translations" :types="types" @startNumber="startNumber" @error="trackError" v-if="step === -1"  />
    <div class="row" v-if="step > -1">
      <EnterNumber :translations="translations" @moveToCode="moveToCode" :type="type" @error="trackError" v-if="step === 0" />
      <EnterCode :translations="translations" @moveToNumber="moveToNumber" :type="type" :msisdn="msisdn" :node="node" @error="trackError" v-if="step === 1" />
      <Finish :translations="translations" @error="trackError" v-if="step === 2" />
    </div>
  </div>
</template>

<script>
import SelectAmount from '@/components/SelectAmount'
import EnterCode from '@/components/EnterCode'
import Finish from '@/components/Finish'
import EnterNumber from '@/components/EnterNumber'

function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}

import api from './apiAccess.js'

export default {
  name: 'App',
  data () {
    return {
      translations: {},
      types: {},
      node: null,
      msisdn: null,
      type: null,
      step: -1
    }
  },
  components: { EnterCode, EnterNumber, Finish, SelectAmount },
  methods: {
    trackError(error) {
      this.trackStep(9, 'error', error, '-1')
    },
    trackStep(step, label, value) {
      this.$ga.event({
        eventCategory: 'top-up',
        eventAction: 'step' + step,
        eventLabel: label,
        eventValue: value
      })
    },
    startNumber(t) {
      this.type = t
      this.step = 0
      this.trackStep(1, 'First step', '-1')
      this.scrollToTop()
    },
    moveToCode(e) {
      this.step = 1
      this.msisdn = e.msisdn
      this.node = e.node
      this.trackStep(2, 'msisdn entered', e.node)
      this.scrollToTop()
    },
    moveToNumber() {
      this.step = 0
      this.msisdn = null
      this.trackStep(5, 'going back to step 0', '-1')
      this.scrollToTop()
    },
    scrollToTop() {
      window.scrollTo(document.getElementById('app').offsetTop, 0)
    }
  },
  mounted() {
    api.loadTranslations().then(r => {
      this.translations = r.translations
      this.types = r.types
      this.trackStep(0, 'loaded translations', '-1')
    })
    var result = findGetParameter('success')
    if (result) {
      this.step = 2
      this.trackStep(4, 'successfull return from payment gateway', '-1')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue